/**
 * S3에서 설정을 불러오지 못했을 때 사용할 기본값
 */
export const DEFAULT_CONFIG = {
  APPLICATION_START_DATE: "2025-04-28T15:00:00Z",
  APPLICATION_CLOSE_DATE: "2025-06-13T14:59:59Z",
}; 